<template>
  <div class="bto-sb-widget bto-sb-widget-prematch-us bto-sb-widget-markets-us">
    <div
      class="bto-sb-widget-title bto-sb-collapsed"
      :class="{
        'bto-sb-show': displayOdds,
        'bto-sb-market-cashout': cashoutEnabledDB && showCashoutIcon && market.cashout,
      }"
      @click="showMarketOdds()">
      <i class="bto-app-cash" v-if="cashoutEnabledDB && showCashoutIcon && market.cashout"></i>
      <h3>{{ market.enrichedMarketName || market.marketName }}</h3>
    </div>
    <div class="bto-sb-widget-content" v-if="displayOdds">
      <div class="bto-sb-market-wrap-items">
        <div class="bto-sb-market-items" v-for="(col, cIdx) in getOutcomesCols.cols" :key="cIdx">
          <MatchOddsDetails
            v-for="(outcome, oIdx) in getOutcomesSlice(col, getOutcomesCols.showMoreBtn)"
            :key="oIdx"
            :match="match"
            :odd="market"
            :outcome="outcome"
            :isDetails="true"
            :lockEmptyOdd="false" />
        </div>
      </div>
      <div class="bto-sb-widget-footer" v-if="getOutcomesCols.showMoreBtn">
        <a
          class="bto-sb-more-item"
          @click="toggleShowOdds"
          :class="{ 'bto-sb-less': showAllOutcomes, 'bto-sb-show': !showAllOutcomes }">
          {{ showAllOutcomes ? t("Mobile.ShowLess") : t("Mobile.ShowMore") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import MatchOddsDetails from './match-odds-details';
  import store from '../../../../store';

  export default {
    name: 'TabMarketUs',
    components: {
      MatchOddsDetails,
    },
    data() {
      return {
        displayOdds: this.showOdds,
        showAllOutcomes: false,
      };
    },
    props: {
      market: {
        type: Object,
      },
      match: {
        type: Object,
        required: true,
      },
      showOdds: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      cashoutEnabledDB() {
        return store.getters.getCashoutDbSetting;
      },
      cashoutEnabledUser() {
        return store.state.playerInfoModule.playerInfo.cashout;
      },
      showCashoutIcon() {
        return !APP_SETTINGS.player.token || this.cashoutEnabledUser;
      },
      getOutcomesCols() {
        const visibleOdds = +APP_SETTINGS.settings.outcomesToShowByDefault || Infinity;
        const distinctColumns = this.market.outcomes.reduce((acc, o) => {
          if (!acc[o.column]) {
            acc[o.column] = [];
          }
          acc[o.column].push(o);
          return acc;
        }, {});
        const distinctColumnsList = Object.keys(distinctColumns).sort((a, b) => (+a) - (+b)).map(dk => distinctColumns[dk]);
        distinctColumnsList.forEach(dc => {
          dc.sort((a, b) => a.orderNo - b.orderNo);
        });
        const showMoreBtn = distinctColumnsList.some((dc) => dc.length > visibleOdds);

        return {
          cols: distinctColumnsList,
          showMoreBtn,
        };
      },
    },
    methods: {
      toggleShowOdds() {
        this.showAllOutcomes = !this.showAllOutcomes;
      },
      getOutcomesSlice(arr, hasShowMore) {
        const visibleOdds = +APP_SETTINGS.settings.outcomesToShowByDefault;
        if (!visibleOdds || !hasShowMore) {
          return arr;
        }
        const chunkSize = this.showAllOutcomes ? Infinity : visibleOdds;
        return arr.slice(0, chunkSize);
      },
      showMarketOdds() {
        this.displayOdds = !this.displayOdds;
      }
    }
  };
</script>
